// Auto generated file, do not manually modify!
// com.hotpads.yourrentalapi.api.web.handler.YourRentalWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetRenterInsuranceUpsellWebApiRequestDto,
  GetRenterInsuranceUpsellWebApiResponseDto,
  GetYourRentalPageDataWebApiResponseDto,
  SendRentPaymentRequestWebApiRequestDto,
} from '../..';

export const YourRentalWebApiHandler_getRenterInsuranceUpsell_Path = '/api/web/v1/getRenterInsuranceUpsell';

/**
 * get renter insurance upsell for your rental page with logged-out user
 */
export const YourRentalWebApiHandler_getRenterInsuranceUpsell = (
  postData: GetRenterInsuranceUpsellWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GetRenterInsuranceUpsellWebApiRequestDto,
    GetRenterInsuranceUpsellWebApiResponseDto
  >(
    {
      endpoint: YourRentalWebApiHandler_getRenterInsuranceUpsell_Path,
      method: 'POST',
      contextPath: '/your-rental-api',
      postData: postData,
    },
    client,
  );
};

export const YourRentalWebApiHandler_getYourRentalPageData_Path = '/api/web/v1/getYourRentalPageData';

/**
 * get your rental page data for logged-in user
 */
export const YourRentalWebApiHandler_getYourRentalPageData = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetYourRentalPageDataWebApiResponseDto>(
    {
      endpoint: YourRentalWebApiHandler_getYourRentalPageData_Path,
      method: 'GET',
      contextPath: '/your-rental-api',
    },
    client,
  );
};

export const YourRentalWebApiHandler_sendRentPaymentRequest_Path = '/api/web/v1/sendRentPaymentRequest';

/**
 * send email to invite landlord to rent-payment
 */
export const YourRentalWebApiHandler_sendRentPaymentRequest = (
  postData: SendRentPaymentRequestWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendRentPaymentRequestWebApiRequestDto, void>(
    {
      endpoint: YourRentalWebApiHandler_sendRentPaymentRequest_Path,
      method: 'POST',
      contextPath: '/your-rental-api',
      postData: postData,
    },
    client,
  );
};
